module.exports = __webpack_public_path__ + "img/hero_aide_memoire.c2d69b7b.jpg";